<template src="./AppHeader.html"></template>

<script lang="ts">
import logo from "@/assets/img/BMWGroup_BMW_MINI_Grey-Colour_RGB.png";
import { defineComponent } from "vue";
import UserBadge from "../UserBadge";

export default defineComponent({
    components: { UserBadge },
    data() {
        return {
            logo: logo
        };
    }
});
</script>

<style src="./AppHeader.scss" lang="scss" scoped></style>
